/**
 * Wording of the "do not upload patient information" notice. Kept free of any
 * dependency so the web tests (which run without web/node_modules) can import it.
 */
export const NO_PHI_NOTICE_TEXT =
  'Do not upload patient information. Files and text you provide must not contain protected health information (PHI), such as subject names, medical record numbers, dates of birth, or completed CRFs with subject data. DocumentSpark is designed for protocols, study design documents and blank forms only.';

export const NO_PHI_CHAT_TEXT = 'Do not enter patient information (PHI) in chat.';
